<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" width="500px">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '120px' } }">
            <a-form-item label="设备型号" name="type">
                <a-cascader v-model:value="cascaderSelectValue" :options="modelOptions" @change="handleSelectModel"
                    placeholder="请选择设备型号" allowClear>
                </a-cascader>
            </a-form-item>

            <a-form-item label="机身号批次" name="batch">
                <a-input v-model:value="formState.batch" placeholder="请输入机身号批次" allowClear>
                </a-input>
            </a-form-item>

            <a-form-item label="机身号个数" name="generationTimes">
                <a-input-number v-model:value="formState.generationTimes" placeholder="请输入生成机身号个数" style="width: 332px;"
                    allowClear>
                </a-input-number>
            </a-form-item>
        </a-form>

    </a-modal>
</template>

<script>
import { defineComponent, nextTick, reactive, ref, watch } from "vue";
import { Toast } from "@/utils";
import {
    randomGZSerial
} from "@/request/view/trialProductionCenter.js";

import { modelOptions } from '@/views/trialProductionCenter/series/data';

export default defineComponent({
    setup(props, context) {
        const formRef = ref();

        const cascaderSelectValue = ref([]);

        const formState = reactive({
            batch: null,
            generationTimes: null,
            letter: null,
            type: null,
            code: null,
        });

        const getWeekByMonth = () => {
            const day = 24 * 60 * 60 * 1000;
            const date = new Date();
            const dayGap = `${date.getFullYear()}-${date.getMonth() + 1}-01`;

            const checkDay = new Date(dayGap).getDay() ? new Date(dayGap).getDay() : 1;

            const timeGap = (((date.getTime() - new Date(dayGap).getTime()) / day) + checkDay).toFixed(0);

            const week = Math.ceil(timeGap / 7)
            return week;
        };

        const setCurrentBatch = () => {
            const date = new Date();

            const currentYear = String(date.getFullYear()).slice(2, 4);
            const currentMonth = date.getMonth() + 1;

            const currentWeek = getWeekByMonth();

            const suppleZeroMonth = currentMonth > 9 ? currentMonth : `0${currentMonth}`;

            formState.batch = `${currentYear}${suppleZeroMonth}${currentWeek}`;
        };

        const checkBatch = async (rule, value) => {
            if (String(value).length !== 5) return Promise.reject('请输入正确的批次号');
            const date = new Date();
            const batch = parseInt(value);

            const year = String(batch).slice(0, 2);
            const month = String(batch).slice(2, 4);
            const week = String(batch).slice(4);

            const currentYear = String(date.getFullYear()).slice(2, 4);

            if (year != currentYear) return Promise.reject('请输入当前年份');
            if (month > 12) return Promise.reject('请输入正确的月份');
            if (week > 5) return Promise.reject('请输入正确的周数');

            return Promise.resolve();
        };

        const rules = {
            batch: [{ required: true, message: '请输入正确的批次号', trigger: 'change', validator: checkBatch }],
            generationTimes: [{ required: true, message: '请输入正确的个数', trigger: 'change', type: 'number' }],
            type: [{ required: true, message: '请选择设备型号', trigger: 'change' }],
        };
        const modalConfig = reactive({
            visible: false,
            title: null,
        });

        const showModal = (type, options) => {
            const { title } = options;
            if (type === "insert") {
                setCurrentBatch()
            }
            modalConfig.title = title;
            modalConfig.visible = true;
            nextTick(() => {
                formRef.value.clearValidate();
            })
        };


        const handleCancel = () => {
            resetForm();
            cascaderSelectValue.value.length = 0;
            modalConfig.title = null;
            modalConfig.visible = false;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formRef.value.clearValidate();
        };

        const handleOk = () => {
            formRef.value
                .validateFields()
                .then((res) => {
                    randomGZSerial(formState).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        };

        const handleSelectModel = (value, options) => {
            const [series, model] = options;
            if (model && model.letter) {
                formState.letter = model.letter;
                formState.type = model.value;
                formState.code = series.value.replace(/\d/g, '').replace(/P/, '').toUpperCase();
                return;
            }

            formState.letter = null;
            formState.type = null;
            formState.code = null;
        };

        return {
            formRef,
            formState,
            rules,
            cascaderSelectValue,
            showModal,
            handleCancel,
            handleOk,
            handleSelectModel,
            modalConfig,
            modelOptions
        };
    },
});
</script>